// extracted by mini-css-extract-plugin
module.exports = {"container":"StopPaymentButton_container__30O8Q","text":"StopPaymentButton_text__2Tyfm","button":"StopPaymentButton_button__2ZF8R"};